import { connect } from 'react-redux'
import userMenuSelector from './userMenuSelector'
import UserMenu from './UserMenu'
import {
  showProfile
} from 'store/redux/layout'
import {
  setUserId as setUserActivitiesId
} from 'store/redux/userActivities'

export default connect(
  userMenuSelector,
  {
    showProfile,
    setUserActivitiesId,
  }
)(UserMenu)
